<template>
    <div class="sticky-legend-compliance">
      <table class="el-table-legends table-bordered mt-4">
        <thead>
          <tr>
            <th class="col-4 py-1 danger">
              {{ $t('common_words.bad') }}
            </th>
            <th class="col-4 py-1 warning">
              {{ $t('common_words.regular') }}
            </th>
            <th class="col-4 py-1 success">
              {{ $t('common_words.good') }}
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </template>
  <script>
  export default {
    name: 'legend-percentage-inventory',
  };
  </script>
  <style>
  .sticky-legend-compliance {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .sticky-legend-compliance .el-table-legends {
    width: 100%;
    margin-bottom: 20px;
    font-size: smaller;
  }
  .danger {
    text-align: center;
    background-color: #ff8484;
  }
  .warning {
    text-align: center;
    background-color: #fed23e;
  }
  .success {
    text-align: center;
    background-color: #5cf062;
  }
  </style>
  